import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        code: null,
        response: null,
    },
    mutations: {
        setCode(state, code) {
            state.code = code;
        },
        setResponse(state, response) {
            state.response = response;
        }
    },
    getters: {
        getCode: state => {
            return state.code;
        },
        getResponse: state => {
            return state.response;
        }
    }
})
